import React from "react";
import { Box, Heading, Text, Icon, VStack, Image } from "@chakra-ui/react";

const FeatureCard = ({
  icon,
  title,
  description,
  titleColor = "#000B8C",
}) => {
  return (
    <Box
      // bg="white"
      borderRadius="lg"
      p={6}
      h="100%"
      display="flex"
      flexDirection="column"
      _hover={{
        shadow: "lg",
        transform: "translateY(-2px)",
        transition: "all 0.2s",
      }}
    >
      <VStack align="start" spacing={4} h="100%">
        {/* Feature Icon */}
        <Box
          fontSize="3xl"
          display="flex"
          alignItems="center"
          justifyContent="center"
          w={16}
          h={16}
          // bg={iconBgColor}
          borderRadius="lg"
          color="white"
        >
          {typeof icon === "string" && icon.includes(".svg") ? (
            <Image src={icon} alt={title} w={16} h={16} />
          ) : (
            <Icon fontSize="2xl" as={icon} />
          )}
        </Box>

        {/* Feature Title */}
        <Heading as="h3" fontSize="lg" color={titleColor} lineHeight="1.3">
          {title}
        </Heading>

        {/* Feature Description */}
        <Text fontSize="sm" color="gray.600" lineHeight="1.6" flex={1}>
          {description}
        </Text>
      </VStack>
    </Box>
  );
};

export default FeatureCard;
